import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { AppColors } from "../../util/AppColors";
import Custom3dotString from "../Custom3dotString";
import CustomButton from "../CustomButton";
import CustomTextField from "../CustomTextField";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CustomSelect = ({
  value,
  handleChange,
  label,
  list,
  selectedBlueColor,
  multiSelectTag,
  select,
  selectFixed,
  error,
  helperText,
  multiSelectTagCheck,
  labelTop,
  newSelect,
  defaultValue,
  scheduleButton,
  disabled,
  multiline,
  addNewSelect,
  backgroundColor,
  name,
  plusBtn,
  mandatoryField,
  search,
  searchOnly,
  reason,
  service,
  addNewItem,
  hoverSelect,
  multiSelectSearchCheck,
  singleSelectSearchCheck,
  maxFilteredOptions,
  showQuantity,
  category,
  isBatchNumber,
  addSearchDirectly,
  isForProcedure,
  showQtyNearExpiry,
}) => {
  const theme = useTheme();
  const formControlRef = useRef(null);
  const dropDownRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(
    list?.find((item) => item?.value === value) || null,
  );
  const [open, setOpen] = useState(false);
  const [srchVal, setSrchVal] = useState(
    typeof value === "string" ? value : "",
  );
  const [dropVsble, setDropVsble] = useState(false);
  const [addNewSearchVal, setAddNewSearchVal] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideInput =
        formControlRef.current && formControlRef.current.contains(event.target);
      const clickedInsideDropdown =
        dropDownRef.current && dropDownRef.current.contains(event.target);

      if (!clickedInsideInput && !clickedInsideDropdown) {
        setDropVsble(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (newSelect) {
      setSelectedValue(list?.find((item) => item?.value === value) ?? null);
    }
    if (addNewSelect) setSrchVal(value);
  }, [value, newSelect, addNewSelect]);

  const handleSelectionChange = (event, newValue) => {
    setSelectedValue(newValue);
    handleChange(newValue ?? "");
  };

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const chipSty = { height: 20, fontSize: 10 };

  const CustomLabel = ({ label, mandatoryField }) => (
    <div className="flex-row-ali-cen">
      <Typography className="font-medium fs14">{label}</Typography>
      {mandatoryField ? <span className="red-color ml2">*</span> : ""}
    </div>
  );

  const filterSearchOptions = (options, inputValue, maxResults = null) => {
    const searchText = inputValue?.trim()?.toLowerCase();
    if (!searchText) return options ?? [];

    const source = options ?? [];
    const limit = maxResults ?? source?.length;
    const results = [];

    for (let i = 0; i < source?.length && results.length < limit; i += 1) {
      const opt = source[i];
      if (opt?._searchText?.includes(searchText)) {
        results.push(opt);
        continue;
      }

      const matches = [
        opt?.name,
        opt?.tradeName,
        opt?.productName,
        opt?.ingredient,
        opt?.serviceName,
        opt?.variantName,
      ].some(
        (field) =>
          field != null && String(field).toLowerCase().includes(searchText),
      );

      if (matches) {
        results.push(opt);
      }
    }

    return results;
  };

  const getLimitedFilterOptions = (options, inputValue) => {
    const trimmed = inputValue?.trim() ?? "";
    if (!trimmed) {
      return (options ?? []).slice(0, maxFilteredOptions);
    }
    return filterSearchOptions(options, trimmed, maxFilteredOptions);
  };

  const isSameSearchOption = (option, selected) => {
    if (!option || !selected) return false;
    if (option?.id != null && selected?.id != null) {
      return option.id === selected.id && option?.name === selected?.name;
    }
    if (option?.value != null && selected?.value != null) {
      return option.value === selected.value;
    }
    if (option?.stockId != null && selected?.stockId != null) {
      return option.stockId === selected.stockId;
    }
    return option?.name === selected?.name;
  };

  const getFilteredList = () => {
    return filterSearchOptions(list, srchVal, maxFilteredOptions ?? undefined);
  };

  function updateArray(val) {
    return value?.includes(val)
      ? value?.filter((item) => item !== val)
      : [...value, val];
  }

  const handleChangeReason = (li) => {
    const reqArr = updateArray(li);
    setSrchVal("");
    handleChange(reqArr);
  };

  function updateServiceArray(itm) {
    const exists = value?.some(
      (item) =>
        item?.variantId === itm?.variantId ??
        item?.serviceId === itm?.serviceId,
    );
    if (exists) {
      return value?.filter(
        (item) =>
          item?.variantId !== itm?.variantId ??
          item?.serviceId !== itm?.serviceId,
      );
    } else {
      return [...value, itm];
    }
  }

  const handleChangeService = (li) => {
    const reqArr = updateServiceArray(li);
    setSrchVal("");
    handleChange(reqArr);
  };

  const handleChangeAddNewItem = (event, newValue) => {
    if (newValue && !list?.includes(newValue)) {
      handleChange({ selcetdValue: newValue, newList: [...list, newValue] });
    } else {
      handleChange({ selcetdValue: newValue, newList: list });
    }
    setAddNewSearchVal("");
    // Clear input helper display
  };

  if (hoverSelect) {
    return (
      <FormControl
        fullWidth
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <InputLabel id="hover-select-label">{label}</InputLabel>
        <Select
          labelId="hover-select-label"
          value={value}
          open={open}
          onChange={handleChange}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        >
          {list?.map((li) => (
            <MenuItem value={li}>{li}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  if (addNewItem) {
    return (
      <>
        <Box>
          <Autocomplete
            freeSolo
            options={list}
            value={value}
            onChange={handleChangeAddNewItem}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                onChange={(e) => setAddNewSearchVal(e?.target?.value)}
              />
            )}
          />
          {addNewSearchVal?.length > 0 && (
            <div
              className="flex-row-ali-cen mt5 cursor"
              onClick={() => handleChangeAddNewItem(null, addNewSearchVal)}
            >
              <div className="txt-semi-bold fs12">Add: </div>
              <div className="blue-color fs14 txt-semi-bold ml5">
                {addNewSearchVal}
              </div>
            </div> // <Chip
            //   label={`Add New: ${addNewSearchVal}`}
            //   color="primary"
            //   variant="outlined"
            //   sx={{ mt: 2 }}
            // />
          )}
        </Box>
      </>
    );
  }

  if (service) {
    return (
      <div ref={formControlRef}>
        <FormControl fullWidth error={error} disabled={disabled}>
          <TextField
            value={srchVal}
            onChange={(e) => {
              const inputVal = e?.target?.value;
              setSrchVal(inputVal);
              setDropVsble(true);
            }}
            autoComplete="off"
            disabled={disabled}
            error={error}
            helperText={helperText}
            // onFocus={() => {
            //   setDropVsble(true); // Show on focus
            // }}
            onClick={() => {
              setDropVsble(!dropVsble);
            }}
            name={name}
            label={label}
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "auto",
                    maxHeight: "none",
                    margin: 0,
                  }}
                >
                  {dropVsble ? (
                    <ArrowDropUpIcon
                      sx={{ color: "action.active", pointerEvents: "none" }}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      sx={{ color: "action.active", pointerEvents: "none" }}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiInputBase-input": {
                paddingRight: 40,
              },
            }}
          />
          {value?.length > 0 && !dropVsble ? (
            <div className="flex-row-wrap1 mt10">
              {value?.map((val, i) => (
                <div
                  className={`flex-row-ali-cen drop-item w48Per mh5 mv5`}
                  key={`${i}-sel-itm`}
                >
                  <div className="w93Per flex-row-ali-cen">
                    <div>
                      <Custom3dotString
                        str={val?.serviceName ?? val?.name}
                        className="font-bold fs14 blue-color"
                        length={25}
                      />
                      <Custom3dotString
                        str={val?.variantName ?? ""}
                        className="font-medium fs12 gray mt5"
                        length={25}
                      />
                    </div>
                    <div className="flex1-end">
                      <div>
                        <Typography className="font-bold fs14 flex-end red-color">
                          Rs {val?.servicePrice ?? ""}
                        </Typography>
                        <Typography className="txt-semi-bold fs14 flex-end mt5 green-color">
                          {val?.estimatedDuration?.length > 0
                            ? `${val?.estimatedDuration} Mins`
                            : ""}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div className="w7Per flex1-end">
                    <CloseIcon
                      sx={{ color: AppColors.red, width: 15, height: 15 }}
                      className="cursor"
                      onClick={() => handleChangeService(val)}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {dropVsble ? (
            <div
              style={{
                position: "relative",
                background: AppColors.white,
                minHeight: 0,
                maxHeight: 200,
                overflowY: "scroll",
                overflowX: "hidden",
                border: "1px solid gray",
                borderRadius: 5,
                width: "100%",
              }}
            >
              {getFilteredList()?.length > 0
                ? getFilteredList()?.map((li, i) => {
                    const isSelected = value?.find(
                      (vl) =>
                        li?.variantId === vl?.variantId ??
                        li?.serviceId === vl?.serviceId,
                    );
                    return (
                      <div key={i} className="w100Per">
                        {i !== 0 && <div className="gry-hor-split3" />}
                        <MenuItem
                          className="flex-row-ali-cen"
                          onClick={() => handleChangeService(li)}
                          style={{
                            background: isSelected ? "#f0f0f0" : "transparent",
                            cursor: "pointer",
                          }}
                        >
                          <div className="w5Per">
                            {isSelected && (
                              <CheckIcon sx={{ color: AppColors.green }} />
                            )}
                          </div>
                          <div className="w95Per">
                            <div className="flex-row-ali-cen">
                              <div>
                                <Custom3dotString
                                  str={li?.serviceName ?? li?.name}
                                  className="font-bold fs14 blue-color"
                                  length={60}
                                />
                                <Custom3dotString
                                  str={li?.variantName ?? ""}
                                  className="font-medium fs12 gray mt5"
                                  length={60}
                                />
                              </div>
                              <div className="flex1-end">
                                <div>
                                  <Typography className="font-bold fs14 flex-end red-color">
                                    Rs {li?.servicePrice ?? ""}
                                  </Typography>
                                  <Typography className="txt-semi-bold fs14 flex-end mt5 green-color">
                                    {li?.estimatedDuration?.length > 0
                                      ? `${li?.estimatedDuration} Mins`
                                      : ""}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                        </MenuItem>
                      </div>
                    );
                  })
                : null}
            </div>
          ) : null}
        </FormControl>
      </div>
    );
  }

  if (reason) {
    return (
      <div ref={formControlRef}>
        <FormControl fullWidth error={error} disabled={disabled}>
          <TextField
            value={srchVal}
            onChange={(e) => {
              const inputVal = e?.target?.value;
              setSrchVal(inputVal);
              setDropVsble(true);
            }}
            autoComplete="off"
            disabled={disabled}
            error={error}
            helperText={helperText}
            // onFocus={() => {
            //   setDropVsble(true); // Show on focus
            // }}
            onClick={() => {
              setDropVsble(!dropVsble);
            }}
            name={name}
            label={label}
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "auto",
                    maxHeight: "none",
                    margin: 0,
                  }}
                >
                  {dropVsble ? (
                    <ArrowDropUpIcon
                      sx={{ color: "action.active", pointerEvents: "none" }}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      sx={{ color: "action.active", pointerEvents: "none" }}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiInputBase-input": {
                paddingRight: 40,
              },
            }}
          />
          {value?.length > 0 && !dropVsble ? (
            <div className="flex-row-wrap1 mh10 mt10">
              {value?.map((val, i) => (
                <div
                  className={`flex-row-ali-cen ${i !== 0 ? "ml10" : ""}`}
                  key={`${i}-sel-itm`}
                >
                  <Typography className="txt-regular fs12">{val}</Typography>
                  <CloseIcon
                    sx={{ color: AppColors.red, width: 15, height: 15 }}
                    className="cursor"
                    onClick={() => handleChangeReason(val)}
                  />
                </div>
              ))}
            </div>
          ) : null}
          {dropVsble ? (
            <div
              style={{
                position: "relative",
                background: AppColors.white,
                minHeight: 0,
                maxHeight: 200,
                overflowY: "scroll",
                overflowX: "hidden",
                border: "1px solid gray",
                borderRadius: 5,
              }}
            >
              {getFilteredList()?.length > 0
                ? getFilteredList()?.map((li, i) => {
                    const isSelected = value?.includes(li?.value);
                    return (
                      <MenuItem
                        // value={li?.value}
                        key={i}
                        className="flex-row-ali-cen"
                        // key={i}
                        onClick={() => handleChangeReason(li?.value)}
                        style={{
                          background: isSelected ? "#f0f0f0" : "transparent",
                          cursor: "pointer",
                        }}
                      >
                        <div className="w5Per flex-center">
                          {isSelected && (
                            <CheckIcon sx={{ color: AppColors.green }} />
                          )}
                        </div>
                        <div className="w95Per">
                          <Custom3dotString
                            str={li?.name}
                            className="font-medium fs14 ml10"
                            length={60}
                          />
                        </div>
                      </MenuItem>
                    );
                  })
                : null}
            </div>
          ) : null}
        </FormControl>
      </div>
    );
  }

  if (search) {
    return (
      <Autocomplete
        disabled={disabled}
        options={list}
        getOptionLabel={(option) => option?.name ?? ""}
        isOptionEqualToValue={(option, selected) =>
          isSameSearchOption(option, selected)
        }
        {...(maxFilteredOptions
          ? {
              filterOptions: (options, { inputValue }) =>
                getLimitedFilterOptions(options, inputValue),
            }
          : {})}
        open={open}
        onOpen={() => {
          if (disabled) return;
          setOpen(true);
        }}
        onClose={() => setOpen(false)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            helperText={helperText}
            size="small"
          />
        )}
        onChange={handleChange}
        value={value ?? null}
        sx={{ background: backgroundColor }}
        fullWidth
        renderOption={(props, option) =>
          showQuantity ? (
            <li
              {...props}
              style={{
                color: option?.name?.toLowerCase()?.includes("(clinic)")
                  ? AppColors.appPrimary // Highlight color for items containing "clinic"
                  : "inherit",
              }}
            >
              <div className="flex-column">
                <div>{option?.name}</div>
                <div className="txt-regular fs12 gray11">
                  Available Qty: {option?.quantity}
                </div>
              </div>
            </li>
          ) : isBatchNumber ? (
            <li {...props} style={{ color: "inherit" }}>
              <div className="flex-column">
                <div>{option?.name}</div>
                <div className="txt-regular fs12 black29 flex-row-wrap1">
                  Location:{" "}
                  <div className="txt-regular fs12 gray11 ml2">
                    {option?.locationName}
                  </div>
                </div>

                <div className="txt-regular fs12 black29 flex-row-wrap1">
                  Qty:{" "}
                  <div className="txt-regular fs12 gray11 ml2">
                    {option?.uomQuantity ?? option?.quantity}
                    {option?.uom?.length > 0 ? ` ${option?.uom}` : ""}
                  </div>
                  {/* <div className="txt-regular fs12 black29 flex-row ml2">
                    (Subunits:{" "}
                    <div className="txt-regular fs12 gray11 ml2">
                      {option?.subunits}
                    </div>
                    )
                  </div> */}
                </div>
              </div>
            </li>
          ) : (
            <li
              {...props}
              style={{
                color: option?.name?.toLowerCase()?.includes("(clinic)")
                  ? AppColors.appPrimary // Highlight color for items containing "clinic"
                  : "inherit",
              }}
            >
              {option?.name}
            </li>
          )
        }
      />
    );
  }

  if (category) {
    return (
      <Autocomplete
        disabled={disabled}
        options={list}
        groupBy={(option) => option?.group}
        getOptionLabel={(option) => option?.name}
        open={open}
        onOpen={() => {
          if (disabled) return;
          setOpen(true);
        }}
        onClose={() => setOpen(false)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            helperText={helperText}
            size="small"
          />
        )}
        onChange={handleChange}
        value={value ?? null}
        sx={{ background: backgroundColor }}
        fullWidth
        renderOption={(props, option) => (
          <li
            {...props}
            style={{
              color: option?.name?.toLowerCase()?.includes("(clinic)")
                ? AppColors.appPrimary // Highlight color for items containing "clinic"
                : "inherit",
            }}
          >
            <div className="flex-column">
              <div>{option?.name}</div>
              <div className="txt-regular fs12 gray11">
                Available Qty: {option?.quantity}
              </div>
            </div>
          </li>
        )}
      />
    );
  }

  if (labelTop) {
    return (
      <>
        {/* {labelTop ? (
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14">{label}</Typography>
            {mandatoryField ? <span className="red-color ml2"> *</span> : ""}
          </div>
        ) : null} */}

        {multiSelectTagCheck ? (
          <FormControl fullWidth error={error}>
            <Select
              size="small"
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={value}
              onChange={handleChange}
              label={label}
              name={name}
              disabled={disabled}
              renderValue={(selected) => (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                    height: 20,
                  }}
                >
                  {selected?.length > 0 &&
                    selected?.map((value) => {
                      const item = list?.find((li) => li?.value === value);
                      return (
                        <Chip
                          key={value}
                          label={item?.name ?? value}
                          sx={chipSty}
                        />
                      );
                    })}
                </Box>
              )}
              sx={{
                backgroundColor: backgroundColor ?? "inherit",
                borderRadius: 1,
                height: 40,
              }}
            >
              {list?.length > 0 &&
                list?.map((li, i) => (
                  <MenuItem key={i} value={li?.value}>
                    <Checkbox checked={value?.indexOf(li?.value) > -1} />
                    <div className="pl10">
                      <ListItemText primary={li?.name} />
                    </div>
                  </MenuItem>
                ))}
            </Select>
            {error ? <FormHelperText>{helperText}</FormHelperText> : null}
          </FormControl>
        ) : select ? (
          <FormControl fullWidth error={error}>
            {/* <InputLabel id="demo-simple-select-label">{label}</InputLabel> */}
            <Select
              size="small"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={value}
              name={name}
              // label={label}
              onChange={handleChange}
              disabled={disabled}
            >
              {list?.length > 0 &&
                list?.map((li, i) => (
                  <MenuItem value={li?.value} key={i}>
                    {Custom3dotString({
                      str: li?.name,
                      length: 40,
                      className: "txt-regular fs14",
                    })}
                  </MenuItem>
                ))}
            </Select>
            {error ? <FormHelperText>{helperText}</FormHelperText> : null}
          </FormControl>
        ) : (
          <FormControl
            sx={{ m: 1, minWidth: 50 }}
            size="small"
            fullWidth
            error={error}
          >
            {/* <InputLabel id="demo-simple-select-helper-label">{label}</InputLabel> */}
            <Select
              size="small"
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={value}
              name={name}
              // label={label}
              onChange={handleChange}
              sx={{ background: AppColors.white }}
              disabled={disabled}
            >
              {list?.length > 0 &&
                list?.map((li, i) => (
                  <MenuItem value={li?.value} key={i}>
                    {li?.name}
                  </MenuItem>
                ))}
            </Select>
            {error ? <FormHelperText>{helperText}</FormHelperText> : null}
          </FormControl>
        )}
      </>
    );
  }

  if (singleSelectSearchCheck) {
    const selectedValue = value ?? null;
    return (
      <Autocomplete
        fullWidth
        id="single-select-search-check"
        options={list}
        value={selectedValue}
        disableClearable
        getOptionLabel={(option) =>
          typeof option === "string" ? option : (option?.name ?? "")
        }
        isOptionEqualToValue={(option, selected) =>
          isSameSearchOption(option, selected)
        }
        filterOptions={(options, { inputValue }) =>
          filterSearchOptions(options, inputValue)
        }
        open={open}
        disabled={disabled}
        onOpen={() => {
          if (disabled) return;
          setOpen(true);
        }}
        onClose={() => setOpen(false)}
        onChange={(event, newValue) => {
          const clickedOption = event.target.closest("li");
          if (clickedOption) {
            const optionText = clickedOption?.textContent?.trim();
            const clickedItem = list.find((item) => item.name === optionText);

            if (
              clickedItem &&
              selectedValue &&
              isSameSearchOption(clickedItem, selectedValue)
            ) {
              handleChange(event, null);
              return;
            }
          }
          handleChange(event, newValue);
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          const isSelected = isSameSearchOption(option, selectedValue);
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={isSelected}
              />
              {option?.name}
            </li>
          );
        }}
        sx={{
          "& .MuiAutocomplete-root": {
            width: "100%",
          },
          "& .MuiOutlinedInput-root": {
            minHeight: 40,
            height: 40,
            padding: "0 8px !important",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            overflow: "hidden",
          },
          "& .MuiAutocomplete-input": {
            minWidth: 0,
            flexGrow: 1,
          },
          "& .MuiInputLabel-root": {
            transform: "translate(14px, 10px) scale(1)",
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={label}
            error={error}
            helperText={helperText}
            sx={{ backgroundColor: backgroundColor ?? "inherit" }}
            fullWidth
            onClick={() => {
              if (disabled) return;
              setOpen(true);
            }}
            disabled={disabled}
          />
        )}
      />
    );
  }

  if (multiSelectSearchCheck) {
    const valueArray = Array.isArray(value) ? value : [];
    return (
      <Autocomplete
        multiple
        fullWidth
        id="checkboxes-tags-demo"
        options={list}
        value={valueArray}
        disableClearable
        disableCloseOnSelect
        getOptionLabel={(option) => option?.name}
        filterOptions={(options, { inputValue }) =>
          filterSearchOptions(options, inputValue)
        }
        open={open}
        disabled={disabled}
        onOpen={() => {
          if (disabled) return;
          setOpen(true);
        }}
        onClose={() => setOpen(false)}
        onChange={(event, newValue) => {
          // Custom toggle logic to handle proper deselection
          const clickedOption = event.target.closest("li");
          if (clickedOption) {
            const optionText = clickedOption?.textContent?.trim();
            const clickedItem = list.find((item) => item.name === optionText);

            if (clickedItem) {
              const isCurrentlySelected = valueArray?.some((item) =>
                isSameSearchOption(clickedItem, item),
              );

              if (isCurrentlySelected) {
                // Remove the item if it's currently selected
                const filteredValue = valueArray?.filter(
                  (item) => !isSameSearchOption(clickedItem, item),
                );
                handleChange({ target: { value: filteredValue, name: name } });
              } else {
                // Add the item if it's not currently selected
                const newValue = [...(valueArray || []), clickedItem];
                handleChange({ target: { value: newValue, name: name } });
              }
            }
          }
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          const isSelected =
            valueArray?.length > 0
              ? valueArray?.some((itm) => isSameSearchOption(option, itm))
              : false;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={isSelected}
              />
              {option?.name}
            </li>
          );
        }}
        sx={{
          "& .MuiAutocomplete-root": {
            width: "100%",
          },
          "& .MuiOutlinedInput-root": {
            minHeight: 40,
            height: 40,
            padding: "0 8px !important",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            overflow: "hidden",
          },
          "& .MuiAutocomplete-input": {
            minWidth: 0,
            flexGrow: 1,
          },
          "& .MuiInputLabel-root": {
            transform: "translate(14px, 10px) scale(1)", // keeps label in place
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)", // standard shrink behavior
          },
        }}
        renderTags={() => {
          // Show tags when dropdown is closed and there are values
          return !open && valueArray?.length > 0
            ? valueArray?.map((option, index) => (
                <Chip
                  key={`${option?.name ?? option?.id}-${index}`}
                  label={option?.name}
                  onDelete={undefined} // 👈 disables the close icon
                  sx={{
                    height: 20,
                    margin: 0.5,
                    "& .MuiChip-deleteIcon": { display: "none" },
                  }}
                />
              ))
            : null;
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={label}
            error={error}
            helperText={helperText}
            sx={{ backgroundColor: backgroundColor ?? "inherit" }}
            fullWidth
            onClick={() => {
              if (disabled) return;
              setOpen(true);
            }}
            disabled={disabled}
          />
        )}
      />
    );
  }

  if (multiSelectTagCheck) {
    return (
      <FormControl fullWidth error={error}>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          size="small"
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={value}
          onChange={handleChange}
          label={label}
          name={name}
          disabled={disabled}
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                height: 20,
              }}
            >
              {selected?.length > 0 &&
                selected?.map((value) => {
                  const item = list?.find((li) => li?.value === value);
                  return (
                    <Chip
                      key={value}
                      label={item?.name ?? value}
                      sx={chipSty}
                    />
                  );
                })}
            </Box>
          )}
          sx={{
            backgroundColor: backgroundColor ?? "inherit",
            borderRadius: 1,
            height: 40,
          }}
        >
          {list?.length > 0 &&
            list?.map((li, i) => (
              <MenuItem key={i} value={li?.value}>
                <Checkbox checked={value?.indexOf(li?.value) > -1} />
                <div className="pl10">
                  <ListItemText primary={li?.name} />
                </div>
              </MenuItem>
            ))}
        </Select>
        {error ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    );
    // return (
    //   <FormControl fullWidth error={error} disabled={disabled}>
    //     {/* <InputLabel id="demo-multiple-chip-label">{label}</InputLabel> */}
    //     <InputLabel id="demo-simple-select-label">{label}</InputLabel>
    //     <Select
    //       size="small"
    //       labelId="demo-multiple-chip-label"
    //       id="demo-multiple-chip"
    //       multiple
    //       value={value}
    //       name={name}
    //       onChange={handleChange}
    //       input={<OutlinedInput id="select-multiple-chip" label={label} />}
    //       renderValue={(selected) => (
    //         <Box
    //           sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, height: 20 }}
    //         >
    //           {selected?.length > 0 &&
    //             selected?.map((value) => (
    //               <Chip key={value} label={value} sx={chipSty} />
    //             ))}
    //         </Box>
    //       )}
    //       sx={{
    //         backgroundColor: backgroundColor ?? "inherit",
    //         borderRadius: 1,
    //         height: 40,
    //       }}
    //     >
    //       {list?.length > 0 &&
    //         list?.map((li, i) => (
    //           <MenuItem key={i} value={li?.value}>
    //             <Checkbox checked={value?.indexOf(li?.value) > -1} />
    //             <div className="pl10">
    //               <ListItemText primary={li?.name} />
    //             </div>
    //           </MenuItem>
    //         ))}
    //     </Select>
    //     {error ? <FormHelperText>{helperText}</FormHelperText> : null}
    //   </FormControl>
    // );
  }

  if (multiSelectTag) {
    return (
      <FormControl fullWidth error={error} disabled={disabled}>
        <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
        <Select
          size="small"
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={value}
          name={name}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label={label} />}
          renderValue={(selected) => (
            <Box
              sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, height: 20 }}
            >
              {selected?.length > 0 &&
                selected?.map((value) => {
                  const item = list?.find((li) => li?.value === value);
                  return (
                    <Chip
                      key={value}
                      label={item?.name ?? value}
                      sx={chipSty}
                    />
                  );
                })}
            </Box>
          )}
        >
          {list?.length > 0 &&
            list?.map((li, i) => (
              <MenuItem
                key={i}
                value={li?.value}
                style={getStyles(li?.value, value, theme)}
              >
                {li?.name}
              </MenuItem>
            ))}
        </Select>
        {error ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    );
  }

  if (selectedBlueColor) {
    return (
      <FormControl
        sx={{ minWidth: 50 }}
        size="small"
        fullWidth
        disabled={disabled}
      >
        <InputLabel id="demo-simple-select-helper-label">{label}</InputLabel>
        <Select
          size="small"
          labelId="demo-simple-select-helper-label"
          id="demo-simple-select-helper"
          value={value}
          label={label}
          onChange={handleChange}
          name={name}
          sx={{
            background: AppColors.white,
            color: AppColors.appPrimary,
            fontWeight: "bold",
            boxShadow: "none",
            ".MuiOutlinedInput-notchedOutline": {
              border: "none !important",
            },
            ".MuiSvgIcon-root ": {
              fill: `${AppColors.appPrimary} !important`,
            },
          }}
        >
          {list?.length > 0 &&
            list?.map((li, i) => (
              <MenuItem value={li?.value} key={i}>
                {li?.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }

  if (select) {
    return (
      <FormControl fullWidth error={error}>
        {/* <div className="flex-row-ali-cen">
          <Typography className="font-medium fs14">{label}</Typography>
          {mandatoryField && label?.length > 0 ? (
            <span className="red-color ml2">*</span>
          ) : (
            ""
          )}
        </div> */}
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          size="small"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          onChange={handleChange}
          defaultValue={defaultValue}
          className="custom-select vets-select"
          sx={{ background: backgroundColor }}
          name={name}
          disabled={disabled}
        >
          {list?.length > 0 &&
            list?.map((li, i) => (
              <MenuItem value={li?.value} key={i}>
                {li?.name}
              </MenuItem>
            ))}
        </Select>
        {error ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    );
  }

  if (scheduleButton) {
    return (
      <FormControl fullWidth error={error} disabled={disabled}>
        {/* <div id="demo-simple-select-label" className="txt-mont fs14 " >{label}</div> */}
        <Select
          size="small"
          // labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          onChange={handleChange}
          defaultValue={defaultValue}
          className="scheduleButton"
          name={name}
          sx={{
            "& .MuiSelect-icon": {
              color: "white", // Change the color to white
              position: "relative", // Position the icon relative for pseudo-element positioning
            },
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
            },
            "& .MuiSelect-select::after": {
              content: '""',
              display: "block",
              width: "1px",
              height: "100%",
              backgroundColor: "white", // Vertical line color
              marginLeft: "auto", // Push line to the right
              marginRight: "8px", // Space between line and arrow
            },
          }}
        >
          {list?.length > 0 &&
            list?.map((li, i) => (
              <MenuItem value={li?.value} key={i}>
                {li?.name}
              </MenuItem>
            ))}
        </Select>
        {error ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    );
  }

  if (selectFixed) {
    return (
      <FormControl fullWidth error={error} disabled={disabled}>
        <div id="demo-simple-select-label-fixed" className="txt-mont fs14 ">
          {label}
        </div>
        <div
          className="demo-simple-select-label-fixed"
          style={{ height: multiline ? "100px" : undefined }}
        >
          {value}
        </div>
        {error ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    );
  }

  if (addNewSelect) {
    return (
      <FormControl fullWidth error={error} disabled={disabled}>
        <div ref={formControlRef} style={{ position: "relative" }}>
          <CustomTextField
            value={srchVal}
            handleChange={(e) => {
              const inputValue = e?.target?.value;
              setSrchVal(inputValue);

              // If addSearchDirectly is true and no matches, auto-select immediately
              if (addSearchDirectly && inputValue?.length > 0) {
                const filtered = list?.filter(
                  (opt) =>
                    opt?.value
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    opt?.ingredient
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    opt?.tradeName
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    opt?.productName
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    opt?.serviceName
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    opt?.variantName
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    opt?.name
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()),
                );

                if (filtered?.length === 0 && !searchOnly) {
                  // No matches found, auto-select the searched value
                  handleChange(inputValue);
                  setDropVsble(false);
                } else {
                  // Matches found, show dropdown
                  setDropVsble(true);
                }
              } else {
                // Normal behavior: show dropdown if there's input
                setDropVsble(inputValue?.length > 0);
              }
            }}
            fullWidth
            disabled={disabled}
            error={error}
            helperText={helperText}
            label={label}
          />
          <Popper
            open={dropVsble && !disabled && !!formControlRef.current}
            anchorEl={formControlRef.current}
            placement="bottom-start"
            style={{ zIndex: 1300 }}
            modifiers={[
              {
                name: "flip",
                enabled: true,
                options: { fallbackPlacements: ["top-start"] },
              },
              {
                name: "preventOverflow",
                enabled: true,
                options: {
                  boundary: "viewport",
                  altAxis: true,
                  padding: 8,
                },
              },
            ]}
          >
            <Paper
              ref={dropDownRef}
              sx={{
                background: AppColors.white,
                minHeight: 0,
                maxHeight: 200,
                overflowY: "auto",
                overflowX: "hidden",
                border: "1px solid rgba(0,0,0,0.12)",
                borderRadius: "4px",
                boxShadow:
                  "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
                mt: 0.5, // ~4px spacing
              }}
              style={{
                width: formControlRef.current?.clientWidth,
                minWidth: formControlRef.current?.clientWidth,
                maxWidth: formControlRef.current?.clientWidth,
              }}
            >
              {getFilteredList()?.length > 0 ? (
                getFilteredList()?.map((li, i) => (
                  <MenuItem
                    value={li?.value}
                    key={i}
                    onClick={() => {
                      setSrchVal(li?.name);
                      handleChange(li);
                      setDropVsble(false);
                    }}
                    style={{
                      width: "100%",
                      whiteSpace: "normal", // allow multi-line text
                      wordBreak: "break-word", // break long words if needed
                    }}
                  >
                    <div>
                      <div className="font-medium fs14 black">{li?.name}</div>
                      {isForProcedure ? (
                        <>
                          {/* <div className="font-medium fs12 gray4">
                            Generic Name: {li?.productName}
                          </div> */}
                          {showQtyNearExpiry ? (
                            <div className="font-medium fs10 red2">
                              Available Qty: {li?.totalQty}
                            </div>
                          ) : null}
                          <div className="flex-row-ali-cen gap4 mt2">
                            {li?.totalQty <= 0 ? (
                              <div className="red-tag white-color font-medium fs10 con-fit">
                                Out of Stock
                              </div>
                            ) : li?.totalQty > 0 && li?.totalQty <= 10 ? (
                              <div className="yellow-tag white-color font-medium fs10 con-fit">
                                Low Stock
                              </div>
                            ) : null}
                            {showQtyNearExpiry && li?.isNearExpiry ? (
                              <div className="org-tag white-color font-medium fs10 con-fit">
                                Near Expiry
                              </div>
                            ) : null}
                          </div>
                        </>
                      ) : null}
                    </div>
                  </MenuItem>
                ))
              ) : searchOnly ? null : addSearchDirectly ? null : (
                <MenuItem
                  value={srchVal}
                  onClick={() => {
                    handleChange(srchVal);
                    setDropVsble(false);
                  }}
                  style={{ width: "100%" }}
                >
                  <div className="flex-row-ali-cen w100Per">
                    <div className="flex-start">
                      <Custom3dotString
                        str={srchVal}
                        className="font-medium fs14"
                        length={20}
                      />
                    </div>
                    <div className="flex1-end">
                      {plusBtn ? (
                        <AddIcon
                          sx={{ color: AppColors.appPrimary }}
                          className="cursor"
                          onClick={() => {
                            handleChange(srchVal);
                            setDropVsble(false);
                            setOpen(false);
                          }}
                        />
                      ) : (
                        <div>
                          <CustomButton
                            text="Add New"
                            smallBtn
                            onClick={() => {
                              handleChange(srchVal);
                              setDropVsble(false);
                              setOpen(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </MenuItem>
              )}
            </Paper>
          </Popper>
        </div>
        {/* <Autocomplete
          disabled={disabled}
          value={value}
          onChange={(event, newValue) => {
            if (typeof newValue === "string") {
              handleChange(newValue);
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              handleChange(newValue.inputValue);
            } else {
              handleChange(newValue);
            }
            setOpen(false);
          }}
          filterOptions={(options, params) => {
            const { inputValue } = params;
            const filtered = options?.filter(
              (opt) =>
                opt?.value
                  ?.toLowerCase()
                  ?.includes(inputValue?.toLowerCase()) ||
                opt?.ingredient
                  ?.toLowerCase()
                  ?.includes(inputValue?.toLowerCase()) ||
                opt?.tradeName
                  ?.toLowerCase()
                  ?.includes(inputValue?.toLowerCase()) ||
                opt?.productName
                  ?.toLowerCase()
                  ?.includes(inputValue?.toLowerCase())
            );
            if (
              inputValue !== "" &&
              !filtered?.find(
                (option) =>
                  option.name?.toLowerCase() === inputValue?.toLowerCase()
              )
            ) {
              filtered?.push({ inputValue, name: inputValue });
            }
            return filtered
              ?.filter((option) => option?.name)
              ?.sort((a, b) => a?.name?.localeCompare(b?.name)); // Sort alphabetically
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          id="free-solo-with-text-demo"
          options={list}
          sx={{ background: backgroundColor }}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === "string") {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            return option.name;
          }}
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            return !list?.find((li) => li?.name?.includes(option?.name)) ? (
              <div className="flex-row">
                <div className="flex-start">
                  <div className="ph10">
                    {option?.name?.split("AddNew ").pop()}
                  </div>
                </div>
                <div className="flex1-end">
                  <div>
                    {plusBtn ? (
                      <AddIcon
                        sx={{ color: AppColors.appPrimary }}
                        className="cursor w30h30"
                        onClick={() => {
                          handleChange(option?.name?.split("AddNew ").pop());
                          setOpen(false);
                        }}
                      />
                    ) : (
                      <CustomButton
                        text="Add New"
                        smallBtn
                        onClick={() => {
                          handleChange(option?.name?.split("AddNew ").pop());
                          setOpen(false);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <li key={key} {...optionProps}>
                {option.name}
              </li>
            );
          }}
          freeSolo
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              error={error}
              helperText={helperText}
              onFocus={() => setOpen(true)}
            />
          )}
          open={open}
          onClose={() => setOpen(false)}
        /> */}
      </FormControl>
    );
  }

  if (newSelect) {
    return (
      <FormControl fullWidth error={error} disabled={disabled}>
        <Autocomplete
          options={list}
          getOptionLabel={(option) => option.name}
          value={selectedValue}
          id="demo-simple-select"
          onChange={handleSelectionChange}
          size="small"
          disabled={disabled}
          renderInput={(params) => (
            <div>
              <TextField
                {...params}
                label={
                  label?.length > 0 ? (
                    <CustomLabel
                      label={label}
                      mandatoryField={mandatoryField}
                    />
                  ) : null
                }
                error={error}
                // helperText={error ? helperText : null}
                id="demo-simple-select"
              />
            </div>
          )}
          fullWidth
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          style={{ overflowY: "auto" }}
          filterOptions={(options, { inputValue }) => {
            return options.filter((option) => {
              const lowercasedInput = inputValue?.toLowerCase();
              return (
                option?.name?.toLowerCase()?.includes(lowercasedInput) ||
                option?.productName?.toLowerCase()?.includes(lowercasedInput)
              );
            });
          }}
        />
        {error && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }

  return (
    <FormControl
      sx={{ m: 1, minWidth: 50 }}
      size="small"
      fullWidth
      disabled={disabled}
    >
      <InputLabel id="demo-simple-select-helper-label">{label}</InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        value={value}
        label={label}
        name={name}
        onChange={handleChange}
        sx={{ background: AppColors.white }}
      >
        {list?.length > 0 &&
          list?.map((li, i) => (
            <MenuItem value={li?.value} key={i}>
              {li?.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

CustomSelect.propTypes = {
  value: PropTypes.string,
  selectedBlueColor: PropTypes.bool,
  multiSelectTag: PropTypes.bool,
  select: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  multiSelectTagCheck: PropTypes.bool,
  labelTop: PropTypes.bool,
  disabled: PropTypes.bool,
  addNewSelect: PropTypes.bool,
  backgroundColor: PropTypes.string,
  name: PropTypes.string,
  plusBtn: PropTypes.bool,
  mandatoryField: PropTypes.bool,
  search: PropTypes.bool,
  searchOnly: PropTypes.bool,
  reason: PropTypes.bool,
  service: PropTypes.bool,
  list: PropTypes.array,
  addNewItem: PropTypes.bool,
  hoverSelect: PropTypes.bool,
  multiSelectSearchCheck: PropTypes.bool,
  singleSelectSearchCheck: PropTypes.bool,
  maxFilteredOptions: PropTypes.number,
  showQuantity: PropTypes.bool,
  category: PropTypes.bool,
  isBatchNumber: PropTypes.bool,
  addSearchDirectly: PropTypes.bool,
};

CustomSelect.defaultProps = {
  value: "",
  selectedBlueColor: false,
  multiSelectTag: false,
  select: false,
  error: false,
  helperText: "",
  multiSelectTagCheck: false,
  labelTop: false,
  disabled: false,
  addNewSelect: false,
  backgroundColor: "transparent",
  name: "",
  plusBtn: false,
  mandatoryField: false,
  search: false,
  searchOnly: false,
  reason: false,
  service: false,
  list: [],
  addNewItem: false,
  hoverSelect: false,
  multiSelectSearchCheck: false,
  singleSelectSearchCheck: false,
  maxFilteredOptions: null,
  showQuantity: false,
  category: false,
  isBatchNumber: false,
  addSearchDirectly: false,
};

export default CustomSelect;
